/* Cart drawer A/B runtime (2026-10-08), deferred. The parse-time traps live in snippets/nk-cart-ab.liquid; this file does:
   1 ask ABConvert for the assignment, write the cookie, hot-swap on the first visit when the cart was not touched yet
   2 stamp the bucket on the cart as attribute nk_cart_ab so orders can be split by bucket */
(function () {
  var S = window.NK_CART_AB; if (!S || !window.theme) return;
  var touched = false;
  document.addEventListener('ajaxProduct:added', function () { touched = true; });
  document.addEventListener('cart:open', function () { touched = true; });
  function setCookie(b) { try { document.cookie = 'nk_cart_ab=' + b + '; path=/; max-age=31536000; SameSite=Lax'; } catch (e) {} }
  function stamp() {
    try { if (sessionStorage.getItem('nk_cart_ab_stamped') === S.bucket) return; } catch (e) {}
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
      if (!c || !c.item_count) return;
      if (c.attributes && c.attributes.nk_cart_ab === S.bucket) { try { sessionStorage.setItem('nk_cart_ab_stamped', S.bucket); } catch (e) {} return; }
      return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { nk_cart_ab: S.bucket } }) }).then(function () { try { sessionStorage.setItem('nk_cart_ab_stamped', S.bucket); } catch (e) {} });
    }).catch(function () {});
  }
  ['ajaxProduct:added', 'cart:build', 'cart:open'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(stamp, 1500); }); });
  function swapTo(b) {
    if (S.mode !== 'ab' || S.bucket === b) return false;
    if (touched || document.documentElement.classList.contains('js-drawer-open') || !S.loser || !S.parent) return false;  /* too late on this page: the cookie fixes the next one */
    var current = document.querySelector('[data-nk-cart="' + S.bucket + '"]');
    if (current && current.parentNode) current.parentNode.removeChild(current);   /* its Drawers / CartForm are now detached: the parse-time traps make them inert */
    S.parent.appendChild(S.loser); S.loser.hidden = false; S.loser = current; S.bucket = b;
    window.NK_CART_VIEW = b === 'variant' ? 'ajax-nk' : 'ajax';
    try { new theme.CartDrawer(); } catch (e) {}
    if (b === 'variant') { if (window.__nkCartDrawer) document.dispatchEvent(new Event('shopify:section:load')); else if (S.inject) S.inject(); }
    try { sessionStorage.removeItem('nk_cart_ab_stamped'); } catch (e) {}
    return true;
  }
  function assign(b) { if (b !== 'variant' && b !== 'control') return; setCookie(b); if (!S.assigned) { S.assigned = true; swapTo(b); } }
  window.__nkCartAb = { assign: assign, state: function () { return { bucket: S.bucket, assigned: S.assigned, view: window.NK_CART_VIEW, touched: touched }; } };
  if (S.mode === 'ab' && S.experiment) {
    window.ABConvertQueue = window.ABConvertQueue || [];
    window.ABConvertQueue.push(function (ABConvert) {
      try { var a = ABConvert && ABConvert.getAssignment && ABConvert.getAssignment(S.experiment); if (a && a.testGroup) assign(a.testGroup.control === false ? 'variant' : 'control'); } catch (e) {}
    });
  }
})();
